import { GenericTable } from './GenericDealListTable';

export default GenericTable;
export type { IGenericTableProps } from './GenericDealListTable';
